import React from 'react';
export const Arrow = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.3772 6.72716C17.4822 8.61216 19.1892 10.3272 20.1592 11.3612H2.26416V12.6912H20.1412C18.611 14.2778 17.0219 15.8066 15.3772 17.2742L16.2642 18.2642C16.3242 18.2102 22.2642 12.8802 22.2642 12.0262C22.2642 11.1502 16.3242 5.79016 16.2642 5.73616L15.3772 6.72716Z"
        fill="#001E50"
      />
    </svg>
  );
};
